module.exports = "/../../dist/frontend/images/agency-pin-available.png?14397bc58e430e644dd6331f85fd2ec0";